import { Box, Button, chakra, Flex, Input, Text } from "@chakra-ui/react";

const LoginFormContainer = chakra(Box, {
  baseStyle: {
    minWidth: { base: "full", md: "400px", lg: "560px" },
    paddingTop: { base: "0px", md: "20px" },
  },
});

const StyledLoginHeading = chakra(Box, {
  baseStyle: {
    fontWeight: "500",
    fontSize: { base: "18px", md: "24px" },
  },
});
const StyledLoginSubHeading = chakra(Box, {
  baseStyle: {
    fontWeight: "500",
    fontSize: { base: "18px", md: "24px" },
    color: "purple.500",
  },
});

const StyledLoginDescription = chakra(Box, {
  baseStyle: {
    fontWeight: "400",
    fontSize: { base: "10px", md: "14px" },
    mt: "7px",
    color: "primary.grayText",
  },
});

export const StyledAuthLinkOrTextBox = chakra(Flex, {
  baseStyle: {
    py: "24px",
    gap: "10px",
    alignItems: "center",
  },
});

export const AuthFormContainer = chakra(Box, {
  baseStyle: {
    display: "flex",
    height: "500px",
    padding: "44px 26px 26px 26px",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "34px",
    borderRadius: "20px",
    border: "4px solid #FFF",
    background: "#FFF",
    boxShadow: `
      0px 3px 11px 0px rgba(24, 25, 180, 0.06),
      0px 10px 18px 0px rgba(24, 25, 180, 0.06)
    `,
    position: "relative",
    overflow: "hidden",
    maxW: "526px",
    w: "100%",
    mx: "auto",
    my: "40px",
  },
});
export const AuthCardEllipse = chakra(Box, {
  baseStyle: {
    width: "474px",
    height: "300px",
    position: "absolute",
    opacity: 0.2,
    background:
      "linear-gradient(180deg, #1819B4 64.45%, rgba(24, 25, 180, 0.00) 106.75%)",
    filter: "blur(77.17774963378906px)",
    pointerEvents: "none",
    zIndex: 0,
  },
});

export const AuthCardTopFrame = chakra(Flex, {
  baseStyle: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "15px",
    alignSelf: "stretch",
    width: "100%",
  },
});
export const AuthInputField = chakra(Input, {
  baseStyle: {
    width: "100%",
    height: "40px",
    borderRadius: "8px",
    borderColor: "#CDD6DC",
    background: "#FFF",
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: 400,
    _focus: {
      borderColor: "#1819B4",
      boxShadow: "0 0 0 1px #1819B4",
    },
    _placeholder: {
      color: "#9CA3AF",
    },
  },
});

export const AuthFieldsWrapper = chakra(Flex, {
  baseStyle: {
    direction: "column",
    gap: "1.5rem",
    width: "100%",
  },
});

export const AuthLabelText = chakra(Text, {
  baseStyle: {
    alignSelf: "stretch",
    color: "#2F2F34",
    fontFamily: "Poppins",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "normal",
  },
});

export const AuthInputBox = chakra(Box, {
  baseStyle: {
    height: "40px",
    borderRadius: "8px",
    borderColor: "#CDD6DC",
    background: "#FFF",
    mb: 0,
    width: "100%",
  },
});
export const AuthCheckboxText = chakra(Text, {
  baseStyle: {
    color: "#2F2F34",
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "normal",
  },
});

export const AuthLinkText = chakra(Text, {
  baseStyle: {
    color: "#1819B4",
    textAlign: "right",
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "normal",
    cursor: "pointer",
    _hover: {
      textDecoration: "underline",
    },
  },
});
export const AuthButtonWrapper = chakra(Flex, {
  baseStyle: {
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    mt: "1.5rem",
    gap: "10px",
  },
});
export const AuthButton = chakra(Button, {
  baseStyle: {
    display: "flex",
    height: "48px",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "stretch",
    borderRadius: "16px",
    background: "#1819B4",
    color: "#FFF",
    textAlign: "center",
    fontFamily: "Poppins",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "normal",
    width: "100%",
    _hover: {
      background: "#1415A0",
    },
    _active: {
      background: "#0F1080",
    },
  },
});
export {
  LoginFormContainer,
  StyledLoginHeading,
  StyledLoginSubHeading,
  StyledLoginDescription,
};
